<template>
  <div class="root">
    <!-- Insert an iframe occupying the full screen -->
    <div ref="root" class="root-content">
      <iframe
        ref="iframe"
        class="full-screen-iframe pt-6"
        frameborder="0"
        sandbox="allow-same-origin allow-scripts allow-popups allow-forms"
        src="about:blank"
        title="Landing Page"
      ></iframe>
    </div>
  </div>
</template>

<script>
// @ is an alias to /src
import { get, error_message, api_host } from "@/utils";

export default {
  name: "Landing",
  components: {},
  methods: {
    redirect() {
      const token = localStorage.getItem("session_token");
      if (token) this.$router.replace({ name: "home" });
      else this.$router.replace({ name: "login" });
    },
    get_page() {
      return new Promise((resolve, reject) => {
        let v = this;
        v.$root.loader(true);
        get("/landing/page/render", { name: v.$route.params.name })
          .then((response) => {
            if (response) {
              v.$refs.iframe.contentWindow.document.open();
              v.$refs.iframe.contentWindow.document.write(response);
              v.$refs.iframe.contentWindow.document.close();
              resolve(response);
            } else {
              error_message(v.$t("page not found"));
              reject(new Error("Page not found"));
            }
          })
          .catch((error) => {
            error_message(error);
            reject(error);
          })
          .finally(() => v.$root.loader(false));
      });
    },
  },
  mounted() {
    window.location.href = `${api_host}/landing/pages/${this.$route.params.name}`;
    // let v = this;
    // // v.get_page();
    // v.$router.push({
    //   path: `${api_host}/landing/page/${v.$route.params.name}`,
    // });
  },
};
</script>

<style scoped>
.full-screen-iframe {
  width: 100%;
  height: 100%;
  border: 0;
}
.root {
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  margin: 0;
  padding: 0;
}
.root-content {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  margin: 0;
  padding: 0;
  overflow: hidden;
}
</style>
